var _defs, _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectbrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__local_offer-24px",
    width: 30,
    height: 31,
    viewBox: "0 -4 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#757575}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_462",
    fill: "none",
    d: "M0 0h30v30H0z",
    "data-name": "Path 462"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_463",
    d: "M26.259 13.973L15.011 2.725A2.484 2.484 0 0 0 13.249 2H4.5A2.507 2.507 0 0 0 2 4.5v8.749a2.494 2.494 0 0 0 .737 1.775l11.249 11.248a2.484 2.484 0 0 0 1.762.728 2.444 2.444 0 0 0 1.762-.737l8.749-8.749A2.444 2.444 0 0 0 27 15.748a2.524 2.524 0 0 0-.741-1.775zM15.748 24.51L4.5 13.249V4.5h8.749v-.013L24.5 15.736z",
    className: "prefix__cls-2",
    "data-name": "Path 463",
    transform: "translate(.502 .502)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_120",
    cx: 1.876,
    cy: 1.876,
    r: 1.876,
    className: "prefix__cls-2",
    "data-name": "Ellipse 120",
    transform: "translate(6.249 6.132)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectbrand);
export default __webpack_public_path__ + "static/media/directbrand.65ccbd79.svg";
export { ForwardRef as ReactComponent };